<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2">
              <div class="col-sm-6">
                <div class="d-flex align-items-center">
                  <label class="mr-2 mb-0">Status:</label>
                  <select class="form-control" style="width: 200px" v-model="filterStatus" @change="updateList">
                    <option value="">Todos</option>
                    <option value="0">Pendentes</option>
                    <option value="1">Aprovados</option>
                    <option value="2">Rejeitados</option>
                  </select>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="float-sm-end">
                  <div class="d-flex align-items-center">
                    <label class="mr-2 mb-0 text-nowrap">Moderação de comentários:</label>
                    <div class="custom-control custom-switch">
                      <input type="checkbox" class="custom-control-input" id="moderationSwitch" v-model="moderationEnabled" @change="toggleModeration">
                      <label class="custom-control-label" for="moderationSwitch">{{ moderationEnabled ? 'Pré-aprovação' : 'Auto-aprovado' }}</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <table class="table table-centered table-nowrap table-hover">
                <thead>
                  <tr>
                    <th>Usuário</th>
                    <th>Vídeo</th>
                    <th>Comentário</th>
                    <th>Status</th>
                    <th>Data</th>
                    <th>Ações</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in comments" :key="item.id">
                    <td>{{ item.user ? item.user.data.name : '-' }}</td>
                    <td>{{ item.video_id }}</td>
                    <td style="max-width: 300px; white-space: normal;">{{ item.comment }}</td>
                    <td>
                      <select class="form-control form-control-sm" style="width: 130px" :value="item.status" @change="changeStatus(item.id, $event.target.value)">
                        <option value="0">Pendente</option>
                        <option value="1">Aprovado</option>
                        <option value="2">Rejeitado</option>
                      </select>
                    </td>
                    <td>{{ formatDate(item.created_at) }}</td>
                    <td>
                      <a href="javascript: void(0);" @click="deleteComment(item.id)" class="text-danger" title="Excluir">
                        <i class="fas fa-trash-alt h5 m-0"></i>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" @input="updateList"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<script>
import Swal from 'sweetalert2'
import Layout from '@/components/layout/vertical'
import PageHeader from '@/components/page-header'
import appConfig from '@/app.config'
import { errorMessage, successMessage } from '@/components/alertsMessages'
import { mapActions, mapState, mapGetters } from 'vuex'
import permissionMixin from '@/mixins/permissionMixin'
import moment from 'moment'

export default {
  mixins: [permissionMixin],
  components: {
    Layout,
    PageHeader
  },
  name: 'VideoComments',
  page: {
    title: 'Moderação de Comentários',
    meta: [{
      name: 'description',
      content: appConfig.description
    }]
  },
  data () {
    return {
      loading: true,
      filterStatus: '',
      totalRows: 1,
      currentPage: 1,
      perPage: 20,
      moderationEnabled: false,
      title: 'Moderação de Comentários de Vídeos',
      items: [{
        text: 'Vídeos'
      },
      {
        text: 'Comentários',
        active: true
      }]
    }
  },
  mounted () {
    this.updateList()
    this.GetSetting()
  },
  computed: {
    ...mapGetters('videoComment', { comments: 'VIDEO_COMMENTS' }),
    ...mapState('videoComment', ['pagination']),
    ...mapState('event', ['setting']),
    rows () {
      return this.pagination.total
    }
  },
  methods: {
    ...mapActions('videoComment', {
      getAll: 'getAll',
      updateStatusAction: 'updateStatus',
      destroyAction: 'destroy',
      updateModerationAction: 'updateModeration'
    }),
    ...mapActions('event', {
      GetSetting: 'GetSetting'
    }),
    formatDate (date) {
      return moment(date).format('DD/MM/YYYY HH:mm')
    },
    async changeStatus (id, status) {
      try {
        await this.updateStatusAction({ id, status: parseInt(status) })
        successMessage('Sucesso: Status atualizado com sucesso.', 2500)
        this.updateList()
      } catch (err) {
        errorMessage('Alerta: ' + err.response.data.message)
      }
    },
    async toggleModeration () {
      try {
        const value = this.moderationEnabled ? 1 : 0
        await this.updateModerationAction({ settingId: this.setting.id, value })
        const label = this.moderationEnabled ? 'Pré-aprovação ativada' : 'Auto-aprovação ativada'
        successMessage('Sucesso: ' + label, 2500)
        this.GetSetting()
      } catch (err) {
        errorMessage('Alerta: ' + err.response.data.message)
      }
    },
    deleteComment (id) {
      Swal.fire({
        title: 'Você tem certeza ?',
        text: 'Essa ação não poderá ser revertida',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#f46a6a',
        cancelButtonColor: '#4a4848',
        cancelButtonText: 'CANCELAR',
        confirmButtonText: 'SIM, DESEJO EXCLUIR!'
      }).then(result => {
        if (result.value) {
          try {
            this.destroyAction(id)
            successMessage('Sucesso: Comentário excluído com sucesso.', 2500)
            this.updateList()
          } catch (err) {
            errorMessage('Alerta: ' + err.response.data.message)
          }
        }
      })
    },
    updateList () {
      let params = {
        status: this.filterStatus !== '' ? this.filterStatus : null,
        limit: this.perPage,
        page: this.currentPage
      }
      let loader = this.$loading.show()
      this.getAll(params).then(() => {
        this.totalRows = this.pagination.total
        this.currentPage = this.pagination.current_page
        loader.hide()
      }).catch(error => {
        console.log(error)
        loader.hide()
      })
    }
  },
  watch: {
    setting (val) {
      if (val) {
        this.moderationEnabled = !!val.video_comments_moderation
      }
    }
  }
}
</script>
<style scoped>
.table-responsive { min-height: 300px; }
.float-sm-end { float: right }
</style>
